import { render, staticRenderFns } from "./TitleForRetrieveLink.vue?vue&type=template&id=06a30da8&scoped=true"
import script from "./TitleForRetrieveLink.vue?vue&type=script&lang=js"
export * from "./TitleForRetrieveLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a30da8",
  null
  
)

export default component.exports